import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

export interface AuthConfig {
  authType: string;
}

export interface BrandingConfig {
  companyName: string;
  applicationName: string;
  title: string;
  description: string;
  faviconBase64: string;
  logoBase64: string;
  logoHeight: number;
  logoWidth: number;
  appVersion: string;
}

export interface StorageConfig {
    hasNetworkFolderPath: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private authConfig?: AuthConfig;
  private brandingConfig?: BrandingConfig;
  private storageConfig?: StorageConfig;
  private readonly configUrl = '/api/Auth/authtype';
  private readonly brandingUrl = '/api/Auth/branding';
  private readonly storageConfigUrl = '/api/Auth/storage-config';

  constructor(
    private http: HttpClient
  ) { }

  loadAuthConfig(): Observable<AuthConfig> {
    return this.http.get<AuthConfig>(this.configUrl).pipe(
      tap(config => {
        this.authConfig = config;
      })
    );
  }

  loadBrandingConfig(): Observable<BrandingConfig> {
    return this.http.get<BrandingConfig>(this.brandingUrl).pipe(
      tap(config => {
        this.brandingConfig = config;
      })
    );
  }

  loadStorageConfig(): Observable<StorageConfig> {
    return this.http.get<StorageConfig>(this.storageConfigUrl).pipe(
      tap(config => {
        this.storageConfig = config;
      })
    );
  }

  getAuthType(): string {
    return this.authConfig?.authType || 'Test';
  }

  getBrandingConfig(): BrandingConfig | undefined {
    return this.brandingConfig;
  }

  getStorageConfig(): StorageConfig | undefined {
    return this.storageConfig;
  }

  hasNetworkFolderPath(): boolean {
    return !!this.storageConfig?.hasNetworkFolderPath;
  }
}
